module.exports = __webpack_public_path__ + "img/avatar4.9f4908ca.png";